import React from "react";
import classNames from "classnames";
import Nav from "../../Nav";

import "./styles.scss";

const Secondary = ({ className, children, ...restProps }) => {
  return (
    <Nav
      className={classNames(
        "mydpd-secondary-nav d-flex justify-content-center",
        className
      )}
      {...restProps}
    >
      {children}
    </Nav>
  );
};

Secondary.propTypes = Nav.propTypes;

export default Secondary;
